import { render, staticRenderFns } from "./DriverDetailsTab.vue?vue&type=template&id=52684fa9&"
import script from "./DriverDetailsTab.vue?vue&type=script&lang=js&"
export * from "./DriverDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports